'use strict';
var on = require('./on'),
    off = require('./off'),
    filter = require('./filter');

module.exports = { on: on, off: off, filter: filter };


/*****************
 ** WEBPACK FOOTER
 ** ./~/dom-helpers/events/index.js
 ** module id = 424
 ** module chunks = 0
 **/